function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "cards");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.543,60h0a2.487,2.487,0,0,0-1.91.889l-1,1.2-4-1.072a2.494,2.494,0,0,0-3.051,1.755L69.514,63H67.893a2.548,2.548,0,0,0-2.542,2.5v9.962L58.973,83.1a2.5,2.5,0,0,0,.319,3.51l3.179,2.663-0.4,1.508a2.481,2.481,0,0,0,1.733,3.05l0.005,0,1.542,0.419V94.5a2.548,2.548,0,0,0,2.54,2.5h3.783l2.9,2.425a2.5,2.5,0,0,0,3.51-.312l1-1.2,4,1.072a2.5,2.5,0,0,0,3.051-1.755L86.2,97h1.621a2.537,2.537,0,0,0,2.529-2.5V84.539l6.385-7.631a2.5,2.5,0,0,0-.321-3.51l-3.175-2.663,0.4-1.508A2.484,2.484,0,0,0,91.9,66.176h0l-1.548-.419V65.509A2.537,2.537,0,0,0,87.824,63H84.041l-2.9-2.425a2.486,2.486,0,0,0-1.6-.575h0Z",
  transform: "translate(-58.397 -60.005)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.981,62.066a1.35,1.35,0,0,1,.35.046l19.252,5.159a1.363,1.363,0,0,1,.961,1.665l-7.5,28a1.364,1.364,0,0,1-1.315,1.007,1.35,1.35,0,0,1-.35-0.046L64.124,92.741a1.363,1.363,0,0,1-.961-1.665l7.5-28a1.364,1.364,0,0,1,1.315-1.007m0-.566a1.929,1.929,0,0,0-1.862,1.427l-7.5,28a1.927,1.927,0,0,0,1.361,2.358l19.252,5.159a1.925,1.925,0,0,0,2.358-1.361h0l7.5-28a1.927,1.927,0,0,0-1.361-2.358L72.477,61.566a1.917,1.917,0,0,0-.5-0.066h0Z",
  transform: "translate(-58.397 -60.005)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.538,61.138a1.352,1.352,0,0,1,.872.316L95.762,74.336a1.254,1.254,0,0,1,.154,1.761L77.21,98.389a1.363,1.363,0,0,1-1.915.167L59.944,85.675a1.254,1.254,0,0,1-.154-1.761L78.5,61.621a1.358,1.358,0,0,1,1.043-.484m0-.566h0a1.922,1.922,0,0,0-1.476.686L59.426,83.466a1.929,1.929,0,0,0,.237,2.712L75.02,99.064a1.161,1.161,0,0,0,.225.152,1.954,1.954,0,0,0,2.4-.464L96.28,76.544a1.929,1.929,0,0,0-.237-2.712L80.774,61.021a1.925,1.925,0,0,0-1.236-.45h0Z",
  transform: "translate(-58.397 -60.005)"
});

var SvgCards = function SvgCards(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 38.913 40.003",
    ref: svgRef
  }, props), _ref2, _ref3, React.createElement("rect", {
    x: 8.132,
    y: 4.147,
    width: 22.65,
    height: 31.709,
    rx: 1.5,
    ry: 1.5,
    style: {
      fill: "#fff"
    }
  }), React.createElement("rect", {
    x: 61.998,
    y: 68.682,
    width: 31.709,
    height: 22.65,
    rx: 1.5,
    ry: 1.5,
    transform: "translate(-77.974 74.495) rotate(-75)",
    style: {
      fill: "#fff"
    }
  }), _ref4, React.createElement("rect", {
    x: 61.998,
    y: 68.68,
    width: 31.709,
    height: 22.65,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(-91.874 28.213) rotate(-50)",
    style: {
      fill: "#fff"
    }
  }), _ref5, React.createElement("rect", {
    x: 63.924,
    y: 70.71,
    width: 27.859,
    height: 18.799,
    transform: "translate(-91.954 28.25) rotate(-50)",
    style: {
      fill: "red"
    }
  }), React.createElement("circle", {
    cx: 77.896,
    cy: 80.042,
    r: 8.494,
    transform: "translate(-91.887 28.259) rotate(-50)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "12.296 17.04 12.929 20.445 18.733 16.981 18.726 21.035 22.717 20.324 20.3 26.629 23.776 26.673 26.176 17.362 21.158 18.137 21.021 13.037 12.296 17.04",
    style: {
      fill: "red"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cards.783f8c55.svg";
export { ForwardRef as ReactComponent };